import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AnalyticsService } from './analytics.service';
import { CartService } from './cart.service';

/**
 * "Buy" everywhere in the theme means: add to the cart, then ask whether to keep shopping or go
 * to the cart. The sweetalert dialog is the same one the Mustache footer script opened.
 */
@Injectable({ providedIn: 'root' })
export class BuyService {

  private cart = inject(CartService);
  private router = inject(Router);
  private analytics = inject(AnalyticsService);

  async buy(productId: number, productName: string, quantity = 1): Promise<void> {
    const result = await this.cart.add(productId, quantity);
    if (!result.ok) {
      await swal({
        title: 'Товар не додано в кошик',
        text: result.error ?? '',
        icon: 'error',
        buttons: ['Закрити']
      });
      return;
    }
    this.report(productName, quantity);
    const toCart = await swal({
      title: productName + ' додано в кошик !',
      text: 'Бажаєте зробити замовлення чи продовжити покупки?',
      icon: 'success',
      buttons: ['Продовжити покупки', 'Замовити']
    });
    if (toCart) {
      await this.router.navigateByUrl('/cart');
    }
  }

  private report(productName: string, quantity: number): void {
    const line = this.cart.cart().products.find(product => product.name === productName);
    if (line) {
      this.analytics.event('add_to_cart', {
        currency: line.price.currency,
        value: (line.price.value ?? 0) * quantity,
        items: [{ item_id: line.productId, item_name: line.name, index: 0, price: line.price.value, quantity }]
      });
    }
  }

}
